module.exports = __webpack_public_path__ + "img/icn_value2.9d428957.svg";